/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m17.755 13.512 3.366 3.367a3 3 0 0 1-4.242 4.242l-3.369-3.368 1.415-1.414 3.368 3.368a1 1 0 0 0 1.414-1.414l-3.367-3.367zm-14.292-.229A6.97 6.97 0 0 1 2 9c0-1.273.34-2.47.937-3.5l.68-1.175 4.23 4.578-1.415 1.414-2.296-2.483a5.017 5.017 0 0 0 .758 4.02zm8.394-8.387 1.431-1.43A6.97 6.97 0 0 0 9 2c-1.04 0-2.028.227-2.917.635l-1.225.562L8.94 7.811l1.417-1.416L8.284 4.05a4.977 4.977 0 0 1 3.574.846zm5.721-2.888 4.43 4.427L6.43 22H2v-4.428zm-2.104 4.93 1.601 1.6 2.104-2.103-1.601-1.6zm.186 3.013-1.601-1.6L4 18.401V20h1.602z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditSettings as EditSettings };
